<template>
  <section
    class="tw-min-h-screen tw-w-full tw-flex tw-items-center tw-pt-10 tw-px-2"
  >
    <div class="tw-max-w-lg tw-w-full tw-mx-auto tw-text-center">
      <a href="/"
        ><img
          src="/imgs/w-logo-full.svg"
          class="tw-w-32 tw-mb-6 tw-mx-auto"
          alt=""
      /></a>
      <!-- <h3 class="tw-font-bold tw-font-sans tw-text-white tw-uppercase tw-text-lg md:tw-text-xl tw-tracking-widest tw-mb-0">@{{$t('about.title_1_of_1')}}</h3> -->
      <h3
        class="tw-font-bold tw-font-sans tw-text-white tw-uppercase tw-text-lg md:tw-text-xl tw-tracking-widest tw-mb-0"
      >
        {{ $page.props.lang == "pt_br" ? pt.title : en.title }}
      </h3>
      <p
        class="tw-text-white tw-font-sans tw-opacity-60 tw-mt-2 tw-mb-10 tw-text-sm md:tw-text-base"
      >
        {{ $page.props.lang == "pt_br" ? pt.sub_title : en.sub_title }}
      </p>
      <!-- <a href="https://app.musicpro.live" target="_blank" class="tw-w-full tw-uppercase tw-text-xs tw-text-white tw-text-center tw-font-sans tw-bg-purple-600 tw-py-4 tw-flex tw-items-center tw-justify-center tw-rounded tw-mt-3 waves-effet waves-light"><i class="fas fa-plus tw-mr-2"></i> {{$page.props.lang == 'pt_br' ? pt.bt : en.bt}}</a> -->

      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <a
              v-bind="attrs"
              v-on="on"
              class="tw-w-full tw-uppercase tw-text-xs tw-text-white tw-text-center tw-font-sans tw-bg-purple-600 tw-rounded-xl tw-py-4 tw-flex tw-items-center tw-justify-center tw-mt-3 waves-effet waves-light"
            >
              <i class="fas fa-plus tw-mr-2"></i>
              {{ $page.props.lang == "pt_br" ? pt.bt : en.bt }}
            </a>
          </template>

          <v-card>
            <div class="modal_title">
              <v-card-title class="tw-uppercase">
                Adicionar artista
              </v-card-title>
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>

            <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                @submit.prevent="saveArtist"
              >
                <v-text-field
                  v-model="nameArtist"
                  :rules="[nameRules, checkArtistExists]"
                  :error-messages="
                    artistExists ? ['Este artista já existe.'] : []
                  "
                  label="Nome do Artista*"
                  required
                ></v-text-field>

                <div class="tw-flex tw-items-center tw-py-2">
                  <v-checkbox v-model="checkbox"></v-checkbox>
                  <span>
                    Confirmo que tenho permissão para administrar este artista e
                    aceito as
                    <a
                      href="https://musicpro.live/faq/politicas"
                      target="_blank"
                      >Políticas e Termos</a
                    >
                    de administração estabelecidos pelo MusicPro.</span
                  >
                </div>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <button
                    :class="{
                      'tw-opacity-50':
                        checkbox === false || nameArtist.length === 0 || !valid
                    }"
                    class="tw-w-full tw-uppercase tw-text-xs tw-rounded-xl tw-text-white tw-bg-purple-600 tw-text-center tw-font-sans tw-py-4 tw-flex tw-items-center tw-justify-center tw-mt-3"
                    :disabled="
                      checkbox === false || nameArtist.length === 0 || !valid
                    "
                  >
                    <span v-if="!loading_bar">Salvar</span>
                    <v-progress-circular
                      indeterminate
                      color="#6E3E8C"
                      v-if="loading_bar"
                    ></v-progress-circular>
                  </button>
                </v-card-actions>
                <div class="tw-px-2" v-if="error_modal">
                  <h1>
                    Desculpe! Estamos com problemas no momento. Por favor, entre
                    em contato com nossa
                    <a href="https://musicpro.live/contato"
                      >central de ajuda.</a
                    >
                  </h1>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>

      <v-text-field
        v-model="q"
        @click:clear="reset"
        color="#6E3E8C"
        dense
        outlined
        clearable
        clear-icon="mdi-close"
        hide-details
        v-bind:label="$page.props.lang == 'pt_br' ? pt.sub_search : en.search"
        type="text"
        append-icon="mdi-magnify"
        @click:append="search"
        @keyup.enter="search"
        class="tw-mt-6"
      />
      <div
        class="tw-w-full tw-flex tw-justify-center tw-items-center tw-mt-3"
        v-if="loading"
      >
        <v-progress-circular
          indeterminate
          color="#6E3E8C"
        ></v-progress-circular>
      </div>
      <ul
        class="tw-w-full tw-text-left tw-pl-0 tw-mt-3 tw-overflow-y-auto"
        style="max-height:350px"
        v-if="!loading"
      >
        <li
          class="tw-w-full tw-border-t tw-border-gray-800 hover:tw-bg-purple-800 tw-transition-all tw-duration-300"
          v-for="(artist, index) in artists"
          :key="index"
        >
          <form action="/user/select-artist" method="POST" v-if="artist">
            <input type="hidden" :value="artist.artista_id" name="artista_id" />
            <input type="hidden" :value="csrf" name="_token" />
            <button
              type="submit"
              class="tw-py-2 tw-w-full tw-flex tw-items-center waves-effect waves-light tw-px-3"
            >
              <img
                :src="
                  artist.post_image !== ''
                    ? artist.post_image
                    : '/imgs/default-avatar.svg'
                "
                onError="this.onerror=null;this.src='/imgs/default-avatar.svg';"
                class="tw-w-8 tw-h-8 md:tw-w-12 md:tw-h-12 tw-object-cover tw-rounded-full tw-mr-5"
              />
              <span
                class="tw-font-sans tw-text-white tw-text-sm md:tw-text-base tw-opacity-60"
                >{{ artist.artista_nome }}</span
              >
            </button>
          </form>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import Layout from "@/Shared/NoMenu";
import en from "../lang/select_artist.js";

export default {
  mixins: [en],
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,
  metaInfo() {
    return {
      title: "Selecione o artista"
    };
  },
  props: ["artists"],
  data() {
    return {
      artistExists: false,
      token: "",
      nameArtist: "",
      checkbox: false,
      q: "",
      loading: false,
      loading_bar: false,
      dialog: false,
      error_modal: false,
      valid: true,
      nameRules: [v => !!v || "Nome requerido"]
    };
  },
  computed: {
    csrf() {
      return document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
    }
  },
  methods: {
    onload: function() {
      if (navigator.languages != undefined)
        if (navigator.languages[0] == "pt" || navigator.language == "pt") {
          var title = "Selecione um artista";
          var sub_title =
            "Clique em um artista abaixo para configurar seu website";
          var bt = "Novo Artista";
          var search = "Pesquisar";
        } else {
          var title = "Select an Artist";
          var sub_title = "Click on an artist below to set up your site";
          var bt = "New Artist";
          var search = "Search";
        }
    },
    search() {
      this.loading = true;
      const vm = this;
      axios
        .get("/api/search-artist", {
          params: {
            uid: this.currentUser.mp_id,
            q: vm.q
          }
        })
        .then(res => {
          this.loading = false;
          this.artists = res.data;
        });
    },
    async checkArtistExists() {
      try {
        const formattedInput = this.nameArtist.trim().toLowerCase();
        const searchVariations = [
          formattedInput,
          formattedInput.replace(/\s+/g, ""),
          formattedInput.replace(/[^a-zA-Z0-9]/g, ""),
          formattedInput.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        ];

        const searchArtists = async () => {
          const response = await axios.get(
            `/api/artists/fetchArtistName?q=${encodeURIComponent(
              formattedInput
            )}`
          );

          const artists = response.data;

          this.artistExists = artists.some(artist => {
            const normalizedArtist = artist
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");
            return searchVariations.some(variation =>
              normalizedArtist.includes(variation)
            );
          });

          return !this.artistExists;
        };

        if (this.searchTimer) {
          clearTimeout(this.searchTimer);
        }

        this.searchTimer = setTimeout(searchArtists, 500);

        return new Promise(resolve => {
          resolve(true);
        });
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    reset() {
      this.loading = true;
      const vm = this;
      axios
        .get("/api/search-artist", {
          params: {
            uid: this.currentUser.mp_id,
            q: ""
          }
        })
        .then(res => {
          this.loading = false;
          this.artists = res.data;
        });
    },
    saveArtist() {
      const vm = this;
      this.loading_bar = true;

      axios
        .post(
          "https://api.musicpro.live:55001/api/musicpro/artist",
          {
            artista_nome: this.nameArtist,
            user_uid: this.currentUser.mp_id
          },
          {
            headers: {
              "x-access-token": this.token
            }
          }
        )
        .then(response => {
          this.dialog = false;
          this.loading_bar = false;
          this.postRedirect({
            artista_id: response.data.data.artista_id,
            _token: vm.csrf
          });
        })
        .catch(response => {
          this.error_modal = true;
          console.log(response);
        });
    },
    register(name, email, password) {
      const vm = this;

      var data = JSON.stringify({
        nome: name,
        email: email,
        senha: password,
        senhaConfirmacao: password
      });

      var config = {
        method: "post",
        url: "https://api.musicpro.live:55001/api/usuario/register",
        headers: {
          "Content-Type": "application/json"
        },
        data: data
      };

      axios(config)
        .then(function(response) {
          vm.authenticate(email, password);
        })
        .catch(function(error) {
          vm.authenticate(email, password);
        });
    },
    authenticate(email, password) {
      const vm = this;

      var data = JSON.stringify({
        email: email,
        senha: password
      });

      var config = {
        method: "post",
        url: "https://api.musicpro.live:55001/api/usuario/autenticar",
        headers: {
          "Content-Type": "application/json"
        },
        data: data
      };

      axios(config).then(function(response) {
        vm.token = response.data.token;
      });
    },
    postRedirect(params) {
      const form = document.createElement("form");
      form.method = "post";
      form.action = "/user/select-artist";

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement("input");
          hiddenField.type = "hidden";
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
    },
    tokenValidation() {
      if (!this.token) {
        this.register(
          this.currentUser.name,
          this.currentUser.email,
          this.currentUser.mp_id
        );
      } else {
        this.authenticate(this.currentUser.email, this.currentUser.mp_id);
      }
    }
  },
  mounted() {
    this.tokenValidation();
  }
};
</script>

<style scope>
input[type="text"]:not(.browser-default) {
  margin: 0 !important;
  border-bottom: 0 !important;
  box-shadow: none !important;
}
.modal_title {
  display: flex;
  justify-content: space-between;
}
</style>
